<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="queryForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item label="增值税发票号：" prop="receiptCode">
        <el-input
            v-model="queryForm.receiptCode"
            size="mini"
            clearable
            type="text"
            placeholder="增值税发票号"
        ></el-input>
      </el-form-item>
      <el-form-item label="外销合同号：" prop="orderCode">
        <order-drop size="mini"
                    v-model="queryForm.orderCode"
                    placeholder="外销合同号"></order-drop>
      </el-form-item>
      <el-form-item label="加工单位：" prop="factoryName">
        <el-input
            type="text"
            size="mini"
            v-model="queryForm.factoryName"
            placeholder="加工单位" :clearable="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="客户：" prop="customerName">
        <el-input
            type="text"
            size="mini"
            v-model="queryForm.customerName"
            placeholder="请输入客户名称" :clearable="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="品番号：" prop="productCode">
        <el-input
            type="text"
            size="mini"
            v-model="queryForm.productCode"
            placeholder="品番号" :clearable="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="SKU：" prop="productSkuCode">
        <el-input
            type="text"
            size="mini"
            v-model="queryForm.productSkuCode"
            placeholder="SKU" :clearable="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="品名：" prop="productName">
        <el-input
            type="text"
            size="mini"
            v-model="queryForm.productName"
            placeholder="品名" :clearable="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="颜色：" prop="productColor">
        <el-input
            type="text"
            size="mini"
            v-model="queryForm.productColor"
            placeholder="颜色" :clearable="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="规格：" prop="productSize">
        <el-input
            type="text" clearable
            size="mini"
            v-model="queryForm.productSize"
            placeholder="规格" :clearable="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="发货日期：">
        <el-date-picker
            v-model="sendDateRange"
            value-format="yyyy-MM-dd"
            size="mini"
            clearable
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="reload" size="mini">查询</el-button>
        <el-button type="warning" size="mini" @click="doExport">导出</el-button>
      </el-form-item>
    </el-form>
    <SweetTable url="/erp/box/report/sell" ref="table" :summaries-column="['sellCount', 'sellAmount', 'checkInCount', 'checkInAmount']"
                :query-form="queryForm" :before-table-binding="beforeTableBinding" api-version="v2">
      <el-table-column
          prop="receiptCode"
          label="增值税发票号"
          header-align="center" :show-overflow-tooltip="true"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="factoryName"
          label="加工单位名称"
          header-align="center"
          align="center"
          width="160"
          :formatter="$c.companyNameFormatter"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          prop="orderCode"
          label="合同号"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="product.code"
          label="品番号"
          header-align="center"
          align="center" :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.skuCode"
          label="SKU"
          header-align="center"
          align="center" :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column prop="product.name" label="品名" header-align="center" :show-overflow-tooltip="true"
                       align="center"></el-table-column>
      <el-table-column prop="product.color" label="颜色" header-align="center" :show-overflow-tooltip="true"
                       align="center"></el-table-column>
      <el-table-column prop="product.size" label="规格" header-align="center" :show-overflow-tooltip="true"
                       align="center"></el-table-column>
      <el-table-column prop="sellCount" label="销售数量" header-align="center" :show-overflow-tooltip="true"
                       align="center" width="80"></el-table-column>
      <el-table-column prop="sellPrice" label="销售单价" header-align="center" :show-overflow-tooltip="true"
                       align="center" width="80"></el-table-column>
      <el-table-column prop="sellAmount" label="销售金额" header-align="center" :show-overflow-tooltip="true"
                       align="center" width="120"></el-table-column>
      <el-table-column prop="checkInCount" label="入库数量" header-align="center" :show-overflow-tooltip="true"
                       align="center" width="80"></el-table-column>
      <el-table-column prop="checkInPrice" label="入库成本单价" header-align="center" :show-overflow-tooltip="true"
                       align="center" width="120"></el-table-column>
      <el-table-column prop="checkInAmount" label="成本金额" header-align="center" width="120"
                       align="center"></el-table-column>
      <el-table-column prop="payReceiptCode" label="成本结算发票号" header-align="center"
                       align="center">
        <template #default="{row}">
          <el-tag size="mini" type="primary" v-for="item in row.receiptDetails" :key="item.id">
            【{{ item.sellerName }}】{{ item.receiptCode }}：{{ item.count }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sendDate" label="发货日期" header-align="center" width="100"
                       align="center"></el-table-column>
      <el-table-column prop="customerName" label="客户名称" header-align="center" width="160"
                       align="center" :formatter="$c.companyNameFormatter"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column
          prop="businessManName" width="100"
          label="业务担当"
          header-align="center"
          align="center" :show-overflow-tooltip="true"
      ></el-table-column>
    </SweetTable>
  </div>
</template>

<script>
// 内销统计
import moment from 'moment'
import BigNumber from 'bignumber.js'
import SweetTable from '@/mixins/SweetTable'

export default {
  name: 'erp-finance-sell-report',
  mixins: [SweetTable],
  data () {
    return {
      datePickerData:[],
      queryForm: {
        receiptCode: '',
        orderCode: '',
        customerName: '',
        productCode: '',
        productSkuCode: '',
        productName: '',
        productColor: '',
        productSize: '',
        factoryName: '',
        beginSendDate: '',
        endSendDate: ''
      },
    }
  },
  activated () {
    this.reload()
  },
  computed: {
    sendDateRange: {
      get: function () {
        return [this.queryForm.beginSendDate, this.queryForm.endSendDate]
      },
      // setter
      set: function (newValue) {
        console.log(newValue)
        this.queryForm.beginSendDate = newValue[0]
        this.queryForm.endSendDate = newValue[1]
      }
    }
  },
  methods: {
    async doExport () {
      // let l = this.$loading()
      // await this.$api.get(`/trade/boxform/caculeall`)
      // l.close()
      await this.$refs.table.export('内销统计')
    },
    beforeTableBinding (dataList) {
      dataList.forEach(item => {
        item.sellPrice = new BigNumber(item.sellAmount).dividedBy(item.sellCount).toFixed(2)
        if(null!=item.checkInPrice&&null!=item.checkInCount){
          item.checkInAmount = new BigNumber(item.checkInPrice).multipliedBy(item.checkInCount).toFixed(2)
        }
        if(!this.$c.isArrayEmpty(item.receiptDetails)){
          item.payReceiptCode=item.receiptDetails.map(r=>r.receiptCode).join(',')
        }
      })
    },
    reset () {
      this.$refs.queryForm.resetFields()
      this.queryForm.year = moment().format('YYYY')
      this.$nextTick(() => {
        this.$refs.table.reload()
      })
    },
  },
  components: {},
}
</script>
